module.exports = __webpack_public_path__ + "img/zb2En.9b6e2bfd.png";